.page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 80px;
  animation: fadeInList .2s ease forwards;
}

.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 32px 0 20px;
}

.title {
  font-family: 'Google Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -.02em;
}

.sub {
  font-size: 14.5px;
  color: var(--muted);
  margin-top: 5px;
  line-height: 1.55;
}

.searchRow { padding-bottom: 24px; }

.searchWrap {
  position: relative;
  max-width: 380px;
}

.searchIcon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--muted2);
  pointer-events: none;
}

.searchInput {
  width: 100%;
  padding: 9px 14px 9px 38px;
  border: 1px solid var(--border);
  border-radius: 20px;
  font-size: 14px;
  background: var(--bg);
  outline: none;
  transition: border-color .15s, background .15s;
  font-family: 'Roboto', sans-serif;
  color: var(--ink);
}

.searchInput:focus {
  border-color: var(--blue);
  background: white;
}

/* Responsive grid — 1 → 2 → 3 columns */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 14px;
}

.state {
  grid-column: 1 / -1;
  padding: 48px 0;
  text-align: center;
  color: var(--muted);
  font-size: 15px;
}

.stateError {
  grid-column: 1 / -1;
  padding: 20px;
  text-align: center;
  color: var(--red);
  background: var(--red-lt);
  border-radius: var(--radius);
  font-size: 14px;
}

.addBtn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 22px;
  background: var(--blue);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 14.5px;
  font-weight: 600;
  font-family: 'Google Sans', sans-serif;
  cursor: pointer;
  letter-spacing: .01em;
  box-shadow: 0 1px 3px rgba(26,115,232,.3);
  transition: background .15s, box-shadow .15s, transform .1s;
  white-space: nowrap;
}

.addBtn:hover {
  background: var(--blue-dk);
  box-shadow: 0 2px 8px rgba(26,115,232,.4);
  transform: translateY(-1px);
}

.addBtn:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(26,115,232,.3);
}
